import { Avatar as AntdAvatar, AvatarProps as AntdAvatarProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';

interface AvatarProp extends AntdAvatarProps {
  avatarUrl?: string;
}

export const Avatar = ({ avatarUrl, ...props }: AvatarProp): JSX.Element => (
  <AntdAvatar src={avatarUrl && avatarUrl} icon={!avatarUrl && <UserOutlined />} {...props} />
);
